import { determineDateTimeAndStatus } from '@eventbrite/event-tickets';

import { TIERED_TICKET_SALES_STATUS_MAP } from './ticketTierUtilsConstants';

/**
 * @typedef {object} StatusDisplayOptions
 * @property {string} statusKey matches one of the ticketStatusConstants
 * @property {string} placement matches one of the TIERED_TICKET_STATUS_PLACEMENTS
 * @property {bool} isDisabled whether the display card should be disabled for interaction
 * @property {bool} hideDescription whether the description for a ticket should be hidden
 * @property {object} textWithPlaceholders status string to display (translated string that needs interpolation)
 */

/**
 * determineTieredOnsaleStatusDisplayOptions
 * @param {Object} ticket
 * @param {String} locale
 * @returns {StatusDisplayOptions} statusDisplayOptions
 **/
export const determineTieredOnsaleStatusDisplayOptions = (ticket, locale) => {
    const dateTimeStatus = determineDateTimeAndStatus(ticket, locale);
    const { statusKey } = dateTimeStatus;
    const salesStatusOption = TIERED_TICKET_SALES_STATUS_MAP[statusKey];
    const { datePropKey, textWithPlaceholders } = salesStatusOption;
    const statusDisplayText = datePropKey
        ? textWithPlaceholders(dateTimeStatus[datePropKey])
        : textWithPlaceholders();
    const className = 'tiered-ticket-onsale-status__date';

    return {
        ...salesStatusOption,
        statusKey,
        statusHtml: ticket.hideSaleDates
            ? { __html: '' }
            : {
                  __html: `<span class="${className}">${statusDisplayText}</span>`,
              },
    };
};
